import React from 'react';
import Col from 'react-bootstrap/Col';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const renderBanner = (widgetType = '', sectionName = '', banner = {}) => {
  const {
    uId = '',
    imageUrl = '',
    bannerUrlLink = '#',
    componentPosition = 0,
    bannerPosition = 0
  } = banner;
  const formattedUrl =
    imageUrl.indexOf('?') == -1 ? imageUrl : imageUrl.substr(0, imageUrl.indexOf('?'));
  return (
    <a
      className="img-animate"
      href={bannerUrlLink}
      data-ga-event-category="bannerTap"
      data-ga-event-action={`${sectionName}/${componentPosition}/${widgetType}`}
      data-ga-event-label={`${formattedUrl}/${bannerPosition}`}
      data-gtm-bnr-position={`${componentPosition}`}
      data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(imageUrl) || ''}`}
      data-gtm-bnr-id={`${uId || ''}`}
    >
      <img src={`${replaceWithJioCDN(imageUrl)}`} />
    </a>
  );
};
class NativeGrid106x54 extends React.Component {
  render() {
    const { pagedetails: { topBannerForNewAppDisabled = false } = {} } = this.props;

    if (!topBannerForNewAppDisabled) {
      const {
        componentTitle = '',
        pagedetails: { typeCode = '', leftBanner = {}, middleBanner = {}, rightBanner = {} } = {}
      } = this.props;

      let imageBanner = null;
      const widgetType = typeCode;
      const sectionName = componentTitle || typeCode;
      imageBanner = (
        <div className="image-banner row">
          <Col xs={4}>{renderBanner(widgetType, sectionName, leftBanner)}</Col>
          <Col xs={4}>{renderBanner(widgetType, sectionName, middleBanner)}</Col>
          <Col xs={4}>{renderBanner(widgetType, sectionName, rightBanner)}</Col>
        </div>
      );
      return <div className="image-com">{imageBanner}</div>;
    }
    return null;
  }
}

export default BannerWrapper(NativeGrid106x54);
